import { render, staticRenderFns } from "./DeminimisBenefitsDetails.vue?vue&type=template&id=20aa634b&scoped=true"
import script from "./DeminimisBenefitsDetails.vue?vue&type=script&lang=js"
export * from "./DeminimisBenefitsDetails.vue?vue&type=script&lang=js"
import style0 from "./DeminimisBenefitsDetails.vue?vue&type=style&index=0&id=20aa634b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aa634b",
  null
  
)

export default component.exports